<template>
  <div id="cd-op-details" class="row d-flex flex-wrap w-100 m-0" style="border-radius: 0.5rem">
    <div
      v-for="(operationDetail, index) in operationDetails"
      :key="operationDetail.key + index"
      class="op-detail-item col-lg-3 col-6 d-flex align-items-center p-0"
    >
      <div class="d-flex flex-column align-items-center w-100 p-3">
        <h6 class="text-center">
          {{ keyToLabel(operationDetail.key) }}
        </h6>
        <h5 class="font-weight-bold text-center">
          <template v-if="isCurrency(operationDetail.key)">
            {{ currency(operationDetail.value) }}
          </template>
          <template v-else-if="isNumberCommas(operationDetail.key)">
            {{ numberCommas(operationDetail.value) }}
          </template>
          <template v-else-if="isDocument(operationDetail.key)">
            <DownloadableFile :href="operationDetail.value" />
          </template>
          <template v-else>
            {{ operationDetail.value }}
          </template>
        </h5>
      </div>
      <div class="op-detail-seperator h-50 bg-secondary" style="width: 1px" />
    </div>
  </div>
</template>

<script>
import DownloadableFile from "../common/DownloadableFile.vue";
import { currency, numberCommas } from "@/services/filters";

export default {
  components: {
    DownloadableFile,
  },
  props: {
    operation: { type: Object, required: true },
  },
  data() {
    return {
      industry: APP_INDUSTRY,
    };
  },
  computed: {
    operationDetails() {
      /*
        ? this houses all the logic for what to display in operation Details
        it was a bit tedious to have the logic all nested in the UI, hence computed property

        ! future sugustion: maybe change the data structure a bit or map this to it's own call?
       */
      const types = {
        operation: this.operation.operation_type.name.toLowerCase(),
        minimum: this.operation.minimum_type,
      };
      return Object.keys(this.operation).reduce((result, operationKey) => {
        const operationValue = this.operation[operationKey];
        const operationDetail = {
          key: operationKey,
          value: operationValue,
        };

        if (!operationValue) {
          return result;
        }

        if (operationKey === "operation_type") {
          if (this.industry == "hemp") {
            operationDetail.value = operationValue.name;
            result.push(operationDetail);
          } else {
            operationDetail.value = operationValue.apex_name;
            result.push(operationDetail);
          }
        }

        if (operationKey === "minimum_order" && types.minimum === "total") {
          result.push(operationDetail);
        }

        if (operationKey === "farm" && types.operation === "farm") {
          Object.keys(operationValue).forEach((farmKey) => {
            const farmValue = operationValue[farmKey];
            if (farmValue) {
              const operationFarmDetail = {
                key: farmKey,
                value: farmValue,
              };

              switch (farmKey) {
                case "harvest_cycle":
                case "grow_environment":
                case "grow_medium":
                case "drying_method":
                case "state_of_material":
                case "storage_type":
                  operationFarmDetail.value = farmValue.name;
                  result.push(operationFarmDetail);
                  break;
                case "farm_acreage":
                case "harvest_size":
                case "ingredients_upload":
                  result.push(operationFarmDetail);
                  break;
              }
            }
          });
        }

        if (operationKey === "fulfillment" && types.operation === "fulfillment") {
          // do whatever is needed here... there wasn't anything previous here in legacy
        }

        if (operationKey === "retailer" && types.operation === "retailer") {
          // do whatever is needed here... there wasn't anything previous here in legacy
        }

        if (operationKey === "distributor" && types.operation === "distributor") {
          Object.keys(operationValue).forEach((distributorKey) => {
            const distributorValue = operationValue[distributorKey];
            if (distributorValue) {
              const operationDistrubutorDetail = {
                key: distributorKey,
                value: distributorValue,
              };

              switch (distributorKey) {
                case "infusion_method":
                case "extraction_method":
                  operationDistrubutorDetail.value = distributorValue.name;
                  result.push(operationDistrubutorDetail);
                  break;
              }
            }
          });
        }

        if (operationKey === "extraction_lab" && types.operation === "extraction lab") {
          Object.keys(operationValue).forEach((extractionLabKey) => {
            const extractionLabValue = operationValue[extractionLabKey];
            if (extractionLabValue) {
              const extractionLabDetail = {
                key: extractionLabKey,
                value: extractionLabValue,
              };

              switch (extractionLabKey) {
                case "extraction_method":
                  extractionLabDetail.value = extractionLabValue.name;
                  result.push(extractionLabDetail);
                  break;
                case "monthy_capacity":
                  result.push(extractionLabDetail);
                  break;
              }
            }
          });
        }

        if (operationKey === "" && types.operation === "product manufacturer") {
          Object.keys(operationValue).forEach((productManufacturerKey) => {
            const productManufacturerValue = operationValue[productManufacturerKey];
            if (productManufacturerValue) {
              const productManufacturerDetail = {
                key: productManufacturerKey,
                value: productManufacturerValue,
              };

              switch (productManufacturerKey) {
                case "infustion_method":
                case "extraction_method":
                  productManufacturerDetail.value = productManufacturerValue.name;
                  result.push(productManufacturerDetail);
                  break;
              }
            }
          });
        }

        return result;
      }, []);
    },
  },
  methods: {
    currency,
    numberCommas,
    keyToLabel(value) {
      // ? converts object key to label
      // example: test_key -> Test Key
      if (!value) return "";
      const string = value.toString();
      return string
        .split("_")
        .map((s) => s[0].toUpperCase() + s.substr(1))
        .join(" ");
    },
    isCurrency(operationDetailKey) {
      // ? if the operationDetail needs currency pipe
      return ["minimum_order"].includes(operationDetailKey);
    },
    isNumberCommas(operationDetailKey) {
      // ? if the operationDetail needs numberCommas pipe
      return ["farm_acreage", "harvest_size"].includes(operationDetailKey);
    },
    isDocument(operationDetailKey) {
      return ["ingredients_upload"].includes(operationDetailKey);
    },
  },
};
</script>

<style lang="scss" scoped>
#cd-op-details {
  display: relative;
  background: #e9ecef;
  border-radius: 0.5rem;

  .op-detail-item {
    h6 {
      color: #a4a4a4;
    }

    h5 {
      color: #64757b;
    }

    &:nth-child(4n) {
      .op-detail-seperator {
        display: none;
      }
    }
    @media screen and (max-width: "991px") {
      &:nth-child(2n) {
        .op-detail-seperator {
          display: none;
        }
      }
    }
  }
}
</style>
